<template>
  <div>
    <vx-card title="Счетчик" class="p-6"> </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
  }),
  components: {},
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
  },
  created() {},
  mounted() {},
};
</script>